"use client";
import React, { useEffect, useRef, useState } from "react";

import classNames from "classnames";
import PropTypes from "prop-types";
import ReCAPTCHA from "react-google-recaptcha";

import { sendProjectRadarSubscription } from "src/services/project-radar";

import validate from "helpers/form-validation";

import SuccessModal from "src/components/listing-search/project-radar-banner/successModal";
import Input from "src/components/common/input";
import CheckBoxItem from "src/components/common/checkbox-item";
import Modal from "@/src/components/common/responsiveModal";
import Button from "src/components/common/button";
import PPLModal from "src/components/emlakjet-link/ppl-modal";
import ProjectRadarSVG from "@/src/assets/svg/components/projectRadar/ProjectRadarSVG";

import styles from "./styles.module.css";

const SubscribeModal = ({ isOpen, close }) => {
  const recaptchaRef = useRef();
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [isPPLModalOpen, setIsPPLModalOpen] = useState(false);
  const [email, setEmail] = useState();
  const [check, setCheck] = useState(false);
  const [activeReCAPTCHA, setActiveReCAPTCHA] = useState(false);
  const [errors, setErrors] = useState();

  const errorProjectRadarCheckbox = classNames({
    [styles.errorCheckbox]: !check && errors?.checkboxError,
  });

  const errorProjectRadarKvkkText = classNames({
    [styles.boldTitle]: !errors?.checkboxError,
    [styles.errorText]: !check && errors?.checkboxError,
  });

  const onChangeInput = (e) => {
    setEmail(e.target.value);
  };
  const handleCheckBox = (e) => {
    setCheck(!check);
  };
  const togglePPLModal = () => setIsPPLModalOpen((prev) => !prev);

  const sendSubscribeForm = () => {
    sendProjectRadarSubscription({
      email,
      fullName: null,
      phoneNumber: null,
    }).then((res) => {
      if (res?.status === "success") {
        close();
        setSuccessModalOpen(true);
      } else {
        setErrors({
          ...errors,
          inputError: res?.description?.tr === "Bu email adresi ile daha önce kayıt yapılmış." && res?.description?.tr,
        });
      }
    });
  };

  const radarFormValidation = async () => {
    const emailInputError = await validate({ email: email === "" ? null : email })?.email?.[0];
    setErrors({
      inputError: emailInputError,
      checkboxError: !check,
    });
    const gRecaptchaResponse = await recaptchaRef.current.execute();
    if (gRecaptchaResponse && !emailInputError && check) {
      recaptchaRef.current.reset();
      sendSubscribeForm();
    }
  };

  const subscribeCloseClick = () => {
    setSuccessModalOpen(false);
  };

  useEffect(() => {
    if (window.env) {
      setActiveReCAPTCHA(true);
    } else {
      setActiveReCAPTCHA(false);
    }
    setErrors();
    setEmail();
    setCheck(false);
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <Modal
          isOpen={isOpen}
          onClose={close}
          size="small"
          title="Proje Radarı Bülteni"
          className="mobile:!bottom-0 mobile:!h-auto mobile:!top-auto"
        >
          <div>
            <div className={styles.projectRadarImg}>
              <ProjectRadarSVG />
            </div>
            <p className={styles.title}>
              Kaydetmiş olduğunuz e-posta adresine her 15 günde bir
              <span className={styles.boldTitle}>
                &nbsp;fırsat projelerin güncel fiyatları ve ödeme avantajları&nbsp;
              </span>
              bülteni iletilecektir.
            </p>

            <div className={styles.content}>
              <div className={styles.emailWrapper}>
                <label className={styles.emailLabel}>E-Posta</label>
                <Input placeholder="E-Posta Giriniz" errorMessage={errors?.inputError} onChange={onChangeInput} />
              </div>
              <CheckBoxItem
                checkBoxClass={styles.clarificationClickText}
                displayClass={errorProjectRadarCheckbox}
                onChange={handleCheckBox}
                title={
                  <p className={styles.clarificationClickText}>
                    Kişisel verilerin işlenmesiyle ilgili&nbsp;
                    <span onClick={togglePPLModal} className={errorProjectRadarKvkkText}>
                      {`Aydınlatma Metni'ni`}
                    </span>
                    &nbsp;okuyup anladığımı beyan ve kabul ederim.
                  </p>
                }
              />
              {activeReCAPTCHA && (
                <ReCAPTCHA
                  key="captcha"
                  ref={recaptchaRef}
                  sitekey={window.env.EJ_KEYS_RECAPTCHA}
                  size="invisible"
                  badge="inline"
                />
              )}

              <div className={styles.SubscribeButtonWrapper}>
                <Button buttonClass={styles.buttons} size="M" onClick={radarFormValidation}>
                  Bültene Abone Ol
                </Button>
              </div>
            </div>
            <PPLModal isOpen={isPPLModalOpen} handleClose={togglePPLModal} />
          </div>
        </Modal>
      )}
      <SuccessModal isOpen={successModalOpen} close={subscribeCloseClick} />
    </>
  );
};

SubscribeModal.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
};

export default SubscribeModal;
